export default __webpack_public_path__ + "static/media/striped_background@2x.c28ef063.png";